import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./DirectorDashboard.css";
import { fetchCastingDirectorDashboardApi } from "../../../services/api";

import DirectorDashboardHeader from "./components/DirectorDashboardHeader";
import DirectorKpiGrid from "./components/DirectorKpiGrid";
import DirectorApplicantsChart from "./components/DirectorApplicantsChart";
import DirectorActiveRolesList from "./components/DirectorActiveRolesList";
import DirectorRecentAuditionsTable from "./components/DirectorRecentAuditionsTable";

const DirectorDashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("all");
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const filteredApplications =
    activeTab === "all"
      ? dashboardData?.recentApplications || []
      : dashboardData?.recentApplications?.filter((item) => {
          const status = String(item?.status || '').toLowerCase();
          if (activeTab === "pending") {
            return status === "pending" || status === "applied";
          }
          if (activeTab === "shortlisted") {
            return (
              status === "shortlisted" ||
              status === "selected"
            );
          }
          return true;
        }) || [];

  const fetchDashboard = async () => {
    try {
      const response = await fetchCastingDirectorDashboardApi();
      setDashboardData(response.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const COLOR_MAP = {
    Shortlisted: "#00c781",
    Selected: "#00c781",
    Pending: "#ffb020",
    Applied: "#ffb020",
    Resubmit: "#a855f7",
    RESUBMIT: "#a855f7",
    Rejected: "#ff4d4f"
  };

  const pieChartData = (dashboardData?.chartData || []).filter(
    (item) => item.value > 0
  );

  const totalApplicantsCount = (dashboardData?.chartData || []).reduce(
    (acc, curr) => acc + (Number(curr.value) || 0), 
    0
  );

  return (
    <div className="dd-wrapper">
      <div className="dd-container">
        <DirectorDashboardHeader navigate={navigate} />

        <DirectorKpiGrid dashboardData={dashboardData} />

        <div className="dd-middle-grid">
          <DirectorApplicantsChart
            pieChartData={pieChartData}
            totalApplicantsCount={totalApplicantsCount}
            COLOR_MAP={COLOR_MAP}
          />

          <DirectorActiveRolesList
            dashboardData={dashboardData}
            navigate={navigate}
          />
        </div>

        <DirectorRecentAuditionsTable
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          filteredApplications={filteredApplications}
          navigate={navigate}
        />
      </div>
    </div>
  );
};

export default DirectorDashboard;